import * as React from 'react';

import type { AlertProps } from "./Alert.props";

const Alert = ({ type = "info", state, text, classNames, children }: AlertProps) => {
	if (!text) {
		return null;
	}

	return (
		<>
			{state ? (
				<div className={`alert alert-${type} ${classNames}`} role="alert">
					<span dangerouslySetInnerHTML={{ __html: text }} />
					{children}
				</div>
			): null}
		</>
	);
};

export { Alert }
